import { api } from "../../axios";

export const actions = {
  generateJevNumber(context, data) {
    return api.get(`JevEntry/JevNumber/${data.cycle}/${data.campusId}`);
  },
  getDraftJevEntries(context, data) {
    return api.get(`JevEntry/Draft/${data.cycle}/${data.campusId}`);
  },
  getPostedJevEntries(context, data) {
    return api.get(`JevEntry/Posted/${data.cycle}/${data.campusId}`);
  },
  createJevEntry(context, data) {
    return api.post(`JevEntry/Add/${data.campusId}`, data);
  },
  updateJevEntry(context, data) {
    return api.put(`JevEntry/${data.id}`, data);
  },
  getSingleJevEntry(context, id) {
    return api.get(`JevEntry/${id}`);
  },
  deleteJevEntry(context, id) {
    return api.delete(`JevEntry/${id}`);
  },
  postJevEntry(context, id) {
    return api.post(`JevEntry/Post/${id}`);
  },
  uploadJevEntries(context, data) {
    return api.post(`JevEntry/Add/Multiple/${data.campusId}`, data.arr);
  },
  postMultipleJevEntries(context, data) {
    return api.post(`JevEntry/Post/Multiple`, data);
  },
  deleteMultipleJevEntries(context, data) {
    return api.post(`JevEntry/Remove/Multiple`, data);
  },
};
